import { Directive, effect, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { NoItemMessageComponent } from './no-item-message/no-item-message.component';

@Directive({
  selector: '[noItemWrapper]',
})
export class NoItemWrapperDirective {
  public readonly noItemWrapper = input.required<any[] | any>();
  public readonly noItemWrapperText = input.required<string>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {
    effect(() => {
      const noItemWrapper = this.noItemWrapper();
      const noItemWrapperText = this.noItemWrapperText();
      this.updateView(noItemWrapper, noItemWrapperText);
    });
  }

  private updateView(noItemWrapper: any[] | any, noItemWrapperText: string): void {
    this.viewContainer.clear();

    if ((Array.isArray(noItemWrapper) && noItemWrapper.length <= 0) || !noItemWrapper) {
      const messageContainer = this.viewContainer.createComponent(NoItemMessageComponent);
      messageContainer.setInput('message', noItemWrapperText);
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
